import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";
import type { PageDto } from "$src/core/models/dto";

const queryKey = () => ["storefront"];

const useStorefrontQuery = (
  options?: Omit<UseQueryOptions<Awaited<PageDto>>, "queryKey" | "queryFn">,
) => {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKey(),
    queryFn: api.getStorefront,
    ...options,
  });
};

export default useStorefrontQuery;
